import { render, staticRenderFns } from "./CommunityNotificationsList.vue?vue&type=template&id=bf5d4638&scoped=true&"
import script from "./CommunityNotificationsList.vue?vue&type=script&lang=ts&"
export * from "./CommunityNotificationsList.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityNotificationsList.vue?vue&type=style&index=0&id=bf5d4638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5d4638",
  null
  
)

export default component.exports